import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppSettingsProvider } from './components/providers/AppSettingsProvider';
import Layout from './components/Layout';
import WhisperPage from "./pages/Whisper";
import Splash from './pages/Splash';
import Onboarding from './pages/Onboarding';
import OnboardingSubscription from './pages/OnboardingSubscription';
import ContentLibrary from './pages/ContentLibrary';
import Profile from './pages/Profile';
import EditAccount from './pages/EditAccount';
import AudioPlayer from './pages/AudioPlayer';
import Journals from './pages/Journals';
import CheckIn from './pages/CheckIn';
import CheckInEvent from './pages/CheckIn/CheckInEvent';
import CheckInEventCustomize from './pages/CheckIn/CheckInEventCustomize';
import CheckInEventCustomizeIcon from './pages/CheckIn/CheckInEventCustomizeIcon';
import CheckInSummary from './pages/CheckIn/CheckInSummary';
import ConversationSummaryDetail from './pages/ConversationSummaryDetail';
import LockedInsightDetail from './pages/LockedInsightDetail';
import InsightDetail from './pages/InsightDetail';
import { Toaster } from './components/ui/sonner';
import { VoiceConfigProvider } from './contexts/VoiceConfigContext';
import Purchase from './pages/Purchase';
import PurchaseSuccess from './pages/PurchaseSuccess';
import ReferralPage from './pages/Referral';

import { NotificationService } from './services/NotificationService';
import { initAnalytics } from './services/analytics';

// Temporary: hide onboarding subscription screen (keep code, don't show UI)
const SHOW_ONBOARDING_SUBSCRIPTION = false;

const App: React.FC = () => {
  React.useEffect(() => {
    NotificationService.initialize();
    initAnalytics();
  }, []);
  return (
    <AppSettingsProvider>
      <VoiceConfigProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/splash" replace />} />
              <Route path="/splash" element={<Splash />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route
                path="/onboarding-subscription"
                element={SHOW_ONBOARDING_SUBSCRIPTION ? <OnboardingSubscription /> : <Navigate to="/whisper" replace />}
              />
              <Route path="/whisper" element={<WhisperPage />} />
              <Route path="/library" element={<ContentLibrary />} />
              <Route path="/player" element={<AudioPlayer />} />
              <Route path="/journals" element={<Journals />} />
              <Route path="/check-in" element={<CheckIn />} />
              <Route path="/check-in/event" element={<CheckInEvent />} />
              <Route
                path="/check-in/event/customize"
                element={<CheckInEventCustomize />}
              />
              <Route
                path="/check-in/event/customize/icon"
                element={<CheckInEventCustomizeIcon />}
              />
              <Route path="/check-in/summary" element={<CheckInSummary />} />
              <Route path="/journal-detail" element={<ConversationSummaryDetail />} />
              <Route path="/insight-locked" element={<LockedInsightDetail />} />
              <Route path="/insight" element={<InsightDetail />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/edit-account" element={<EditAccount />} />
              <Route path="/purchase" element={<Purchase />} />
              <Route path="/purchase-success" element={<PurchaseSuccess />} />
              <Route path="/referral" element={<ReferralPage />} />
            </Routes>
          </Layout>
        </Router>
        <Toaster />
      </VoiceConfigProvider>
    </AppSettingsProvider>
  );
};

export default App;